import Swal from "sweetalert2";
import { call, put, takeLatest } from "redux-saga/effects";
import * as actionTypes from "../action-types";
import { getAPI, postAPI } from "../../utils/api-function";
import { get_payout_settings, toggle_auto_payout, get_pending_payouts, process_payout, process_all_payouts, get_payout_history } from "../../utils/api-routes";

function* getPayoutSettingsSaga() {
    try {
        const response = yield call(getAPI, get_payout_settings);
        if (response?.data?.status) {
            yield put({ type: actionTypes.SET_PAYOUT_SETTINGS, payload: response.data.result });
        }
    } catch (error) {
        console.log("Get Payout Settings Error:", error);
    }
}

function* toggleAutoPayoutSaga(action) {
    try {
        const { data, onComplete } = action.payload;
        const response = yield call(postAPI, toggle_auto_payout, data);
        if (response?.data?.status) {
            yield put({ type: actionTypes.SET_PAYOUT_SETTINGS, payload: { auto_payout_enabled: data.enabled } });
            Swal.fire({ icon: "success", title: "Success", text: response.data.message });
            if (onComplete) yield call(onComplete);
        } else {
            Swal.fire({ icon: "error", title: "Error", text: response?.data?.message || "Failed to toggle auto payout" });
        }
    } catch (error) {
        Swal.fire({ icon: "error", title: "Error", text: error?.response?.data?.message || error?.message || "Something went wrong" });
    }
}

function* getPendingPayoutsSaga() {
    try {
        const response = yield call(getAPI, get_pending_payouts);
        if (response?.data?.status) {
            yield put({ type: actionTypes.SET_PENDING_PAYOUTS, payload: response.data.result });
        } else {
            yield put({ type: actionTypes.SET_PENDING_PAYOUTS, payload: { admins: [], partners: [], affiliates: [], total_pending: 0 } });
        }
    } catch (error) {
        console.log("Get Pending Payouts Error:", error);
        yield put({ type: actionTypes.SET_PENDING_PAYOUTS, payload: { admins: [], partners: [], affiliates: [], total_pending: 0 } });
    }
}

function* processPayoutSaga(action) {
    try {
        const { data, onComplete } = action.payload;
        const response = yield call(postAPI, process_payout, data);
        if (response?.data?.status) {
            Swal.fire({ icon: "success", title: "Success", text: response.data.message });
            if (onComplete) yield call(onComplete);
        } else {
            Swal.fire({ icon: "error", title: "Error", text: response?.data?.message || "Payout failed" });
        }
    } catch (error) {
        Swal.fire({ icon: "error", title: "Error", text: error?.response?.data?.message || error?.message || "Something went wrong" });
    }
}

function* processAllPayoutsSaga(action) {
    try {
        const { onComplete } = action.payload || {};
        const response = yield call(postAPI, process_all_payouts, {});
        if (response?.data?.status) {
            const result = response.data.result;
            Swal.fire({ icon: "success", title: "Batch Payout Complete", text: response.data.message });
            if (onComplete) yield call(onComplete);
        } else {
            Swal.fire({ icon: "error", title: "Error", text: response?.data?.message || "Batch payout failed" });
        }
    } catch (error) {
        Swal.fire({ icon: "error", title: "Error", text: error?.response?.data?.message || error?.message || "Something went wrong" });
    }
}

function* getPayoutHistorySaga(action) {
    try {
        const params = action.payload || {};
        const route = get_payout_history(params);
        const response = yield call(getAPI, route);
        if (response?.data?.status) {
            yield put({ type: actionTypes.SET_PAYOUT_HISTORY, payload: response.data.result });
        } else {
            yield put({ type: actionTypes.SET_PAYOUT_HISTORY, payload: { payouts: [], total: 0, page: 1, pages: 0, summary: {} } });
        }
    } catch (error) {
        console.log("Get Payout History Error:", error);
        yield put({ type: actionTypes.SET_PAYOUT_HISTORY, payload: { payouts: [], total: 0, page: 1, pages: 0, summary: {} } });
    }
}

export default function* payoutSaga() {
    yield takeLatest(actionTypes.GET_PAYOUT_SETTINGS, getPayoutSettingsSaga);
    yield takeLatest(actionTypes.TOGGLE_AUTO_PAYOUT, toggleAutoPayoutSaga);
    yield takeLatest(actionTypes.GET_PENDING_PAYOUTS, getPendingPayoutsSaga);
    yield takeLatest(actionTypes.PROCESS_PAYOUT, processPayoutSaga);
    yield takeLatest(actionTypes.PROCESS_ALL_PAYOUTS, processAllPayoutsSaga);
    yield takeLatest(actionTypes.GET_PAYOUT_HISTORY, getPayoutHistorySaga);
}
